import React, { useState } from 'react';
import classNames from 'classnames';
import Popover from './popover';
import Icon, { ICONS, COLORS } from './icon';

interface Props {
	editCallback(): void;
	copyCallback?: () => void;
	deleteCallback(): void;
	buttonClassNames?: string;
	grayEllipses?: boolean;
	showEditDelete?: boolean;
}

export default function EditEllipses(props: Props) {
	const {
		editCallback,
		copyCallback,
		deleteCallback,
		buttonClassNames,
		grayEllipses,
		showEditDelete,
	} = props;

	const [popoverOpen, setPopoverOpen] = useState(false);

	return (
		<div className='edit-ellipses-container'>
			<button className='ellipses transparent' onClick={(e) => {
				e.stopPropagation();
				popoverOpen ? setPopoverOpen(false) : setPopoverOpen(true);
			}}>
				<Icon name={ICONS.THREE_DOTS_HORIZONTAL} color={grayEllipses ? COLORS.DARK_GRAY_2 : COLORS.WHITE} size={16} />
			</button>
			<Popover
				open={popoverOpen}
				close={() => setPopoverOpen(false)}
				className="edit-ellipses-menu field-group select"
			>
				<>
					{showEditDelete && (
						<button className={classNames(buttonClassNames, 'select-option', 'transparent')} onClick={(e) => {
							e.stopPropagation();
							editCallback();
							setPopoverOpen(false);
						}}>
							<Icon name={ICONS.EDIT} color={COLORS.WHITE} size={10} className='margin-right-small' />
							<span className='text'>Edit</span>
						</button>
					)}
					{copyCallback && (
						<button className={classNames(buttonClassNames, 'select-option', 'transparent')} onClick={(e) => {
							e.stopPropagation();
							copyCallback();
							setPopoverOpen(false);
						}}>
							<Icon name={ICONS.TEMPLATE_ADD} color={COLORS.WHITE} size={10} className='margin-right-small' />
							<span className='text'>Copy</span>
						</button>
					)}
					{showEditDelete && (
						<button className={classNames(buttonClassNames, 'select-option critical-option', 'text-warning')} onClick={(e) => {
							e.stopPropagation();
							deleteCallback();
							setPopoverOpen(false);
						}}>
							<Icon name={ICONS.TRASH} color={COLORS.RED} size={10} className='margin-right-small' />
							<span className='text'>Remove</span>
						</button>
					)}
				</>
			</Popover>
		</div>
	);
}
